import { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Form, Input, Spin } from 'antd';
import { RefreshIcon } from 'icons';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { onOpenVerifyBot } from 'modules/auth';

interface IProps {
  phone?: string;
  onSendOtp: (value: { phone: string }) => void;
  onChangePhone: () => void;
  resendLoading?: boolean;
  selectedMethod?: 'sms' | 'telegram';
}

export function OtpStep({ phone, onSendOtp, resendLoading, selectedMethod }: IProps) {
  const t = useTranslations();
  const [secondsLeft, setSecondsLeft] = useState(59);
  const [resendVisible, setResendVisible] = useState(false);

  const onResend = () => {
    if (!phone) return;
    if (selectedMethod === 'telegram') {
      onOpenVerifyBot(phone);
      return;
    }
    onSendOtp({ phone });

    setSecondsLeft(60);
    setResendVisible(false);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (secondsLeft > 0) {
      timer = setTimeout(() => setSecondsLeft(prev => prev - 1), 1000);
    } else {
      setResendVisible(true);
    }

    return () => clearTimeout(timer);
  }, [secondsLeft]);

  return (
    <>
      <Form.Item
        name="code"
        className="!mb-0"
        label={t('auth.otp_validation_message')}
        rules={[{ required: true, message: 'Kod kiriting' }]}
      >
        <PatternFormat
          format="#####"
          allowEmptyFormatting
          mask="_"
          customInput={Input}
          suffix={
            resendVisible ? (
              <div onClick={onResend} className="cursor-pointer text-green-500">
                <Spin spinning={resendLoading} indicator={<LoadingOutlined />}>
                  <RefreshIcon />
                </Spin>
              </div>
            ) : (
              <Spin spinning={resendLoading} indicator={<LoadingOutlined />}>
                <span className="text-sm text-gray-400">{`00:${secondsLeft.toString().padStart(2, '0')}`}</span>
              </Spin>
            )
          }
          placeholder="_____"
          className="!flex !h-11 items-center !rounded-lg tracking-widest"
        />
      </Form.Item>
    </>
  );
}
